module.exports = __webpack_public_path__ + "static/img/101032.14055ecc.png";